<!-- <app-survay-header></app-survay-header> -->
<div class="Main-Cont">
    <div class="Ques-cont">
        <div class="text-dark fs-5 fw-bold">
            <!-- Which city do you live in&#63; -->
            {{qService.currentQuestion.question_text}}
        </div>
        <div class="text-muted fs-6 fw-normal mt-2">
            You can choose only one options
        </div>
        <div class="row Image-Cont">
            <!-- <div class="ng-autocomplete">
                <div class="input-container">
                    <ng-autocomplete
                        [data]="qService.filterCityArr"
                        [searchKeyword]="keyword"
                        placeholder="Start typing to search options:"
                        (selected)='selectEvent($event)'
                        (inputChanged)='onChangeSearch($event)'
                        (inputFocused)='onFocused($event)'
                        [itemTemplate]="itemTemplate"
                        [notFoundTemplate]="notFoundTemplate">
                    </ng-autocomplete>
                </div>
            
              <ng-template #itemTemplate let-item>
                <a [innerHTML]="item.name"></a>
              </ng-template>
            
              <ng-template #notFoundTemplate let-notFound>
                <div [innerHTML]="notFound"></div>
              </ng-template>
            </div> -->

            <div class="input-container" >
                <input class="Form-input" on-focus="onFocusIn()" on-focusout="onFocusOut()" type="text" #input placeholder="Your Answer Here:" value={{value}} (input)="onInputChange($event)" />
                <div (click)="onCloseKeboard()" *ngIf="isKeyboardReInstanciated"><i class="fa fa-keyboard-o on" aria-hidden="true"></i></div>
                <div (click)="onOpenKeyboard()" *ngIf="!isKeyboardReInstanciated"><i class="fa fa-keyboard-o off" aria-hidden="true"></i></div>
            </div>
            <div class="list-container shadow" *ngIf="focusShow" #searchDataRef>
                <div *ngFor="let city of filterdData" (click)="selectCity(city);$event.stopPropagation()">{{city.name}}</div>
            </div>
            <!-- <div class="list-container shadow" *ngIf="focusShow" #searchDataRef>
                <div *ngFor="let city of filterCityArr | filterlist:value" (click)="selectCity(city);$event.stopPropagation()">{{city.name}}</div>
            </div> -->
        </div>
    </div>
    <div class="footer-container">
        <div class="simple-keyboard" #simpleKeyboardRef></div>
        <div class="footer">
            <div class="text-end">
                <div class="text-dark fw-bold fs-4">Q{{qService.currentQuestion.ques_index}}</div>
            </div>
            <div class="text-end">
                <button class="btn btn-primary" (click)="next()">Next</button>
            </div>
        </div>
    </div>
</div>
